import { AxiosError, AxiosInstance } from 'axios';
import { DashStats, Stats } from 'types/general.type';
import { errorHandler } from 'utils';

class GeneralService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  getActivities = async (): Promise<any> => {
    try {
      const response = await this.baseService.get('/activities');
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getAllocatedStat = async (): Promise<Stats> => {
    try {
      const response = await this.baseService.get('/activities/stats');
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getDashboardStat = async (): Promise<DashStats> => {
    try {
      const response = await this.baseService.get(
        '/activities/dashboard/stats'
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default GeneralService;
